<template>
  <CustomModal
    id="upgrade-plan-without-permission"
    width="496"
    modalClass="custom-modal_xl"
  >
    <template #header>
      <BaseHeading
        level="3"
        color="monochrome-06"
      >
        Upgrade Plan
      </BaseHeading>
    </template>

    <template #body>
      <BaseSubHeading
        size="large"
        weight="400"
        color="monochrome-06"
      >
        Please contact Account owner to upgrade the account ({{ accountOwner }}).
      </BaseSubHeading>
    </template>

    <template #footer="{ hide }">
      <ControlButtons
        :hideCancel="true"
        @save="onConfirm(hide)"
      >
        <template #save> OK </template>
      </ControlButtons>
    </template>
  </CustomModal>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useStore } from "vuex"

import BaseSubHeading from "@/components/Base/BaseSubHeading.vue"
import ControlButtons from "@/components/ControlButtons/index.vue"
import CustomModal from "@/components/Modal/index.vue"

import { Getters } from "@/store"

const onConfirm = hide => hide()
const store = useStore()

const accountOwner = computed(() => {
  const account = store.getters[Getters.GET_ACCOUNT]
  const owner = account?.owner
  return owner ? owner.fullName : ""
})
</script>

<style lang="scss">
@import "@/assets/scss/utils/mixins/_flex";
</style>
